module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/icon-journal.c57b4736.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/icon-journal.png
// module id = 3075
// module chunks = 11